import axios from "axios";
import { Edit2 } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { Select } from "antd";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { Input } from "src/components/ui/input";

export const SalaryEditSheet = ({
  selectedRecord,
  handleFetchSalary,
  users,
  loadingUsers,
}) => {
  const [showEditSheet, setShowEditSheet] = useState(false);
  const [editRecord, setEditRecord] = useState({
    user_id: selectedRecord?.user.id || 0,
    value: selectedRecord?.value || 0,
    total_deduction: selectedRecord?.total_deduction || 0,
    total_bonus: selectedRecord?.total_bonus || 0,
    payed: selectedRecord?.payed || false,
    payed_by: selectedRecord?.payed_by || "",
  });
  const [loadingEdit, setLoadingEdit] = useState(false);

  const [errors, setErrors] = useState({});
  const handleEdit = async (e) => {
    e.preventDefault();
    setLoadingEdit(true);
    setErrors({});

    try {
      await axios.put(
        `${BaseUrlApi}/salaries/${selectedRecord.bid}`,
        editRecord
      );
      toast("تم التعديل", {
        description: "تم تعديل الراتب بنجاح 🎉",
      });

      await handleFetchSalary();
      setShowEditSheet(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
      setErrors(result);
    } finally {
      setLoadingEdit(false);
    }
  };

  return (
    <Sheet open={showEditSheet} onOpenChange={setShowEditSheet}>
      <SheetTrigger asChild>
        <Button
          size="sm"
          className="rounded-lg px-2 text-green-600"
          variant="ghost"
          disabled={loadingUsers}
        >
          <Edit2 />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" dir="rtl" className="overflow-auto">
        <SheetHeader className="text-start">
          <SheetTitle>تعديل راتب جديد</SheetTitle>
        </SheetHeader>
        <div className="space-y-4 mt-3">
          <div className="flex-1">
            <label className="block font-medium mb-1">اختر عضو</label>
            <Select
              placeholder="اختر عضو"
              value={editRecord.user_id}
              onChange={(e) => setEditRecord({ ...editRecord, user_id: e })}
              style={{ width: "100%" }}
              options={users.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
          </div>

          <div className="space-y-2">
            <label className="block font-medium">الراتب</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الراتب"
              value={editRecord.value || ""}
              onChange={(e) =>
                setEditRecord({ ...editRecord, value: +e.target.value })
              }
            />
            {errors?.salary && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.salary[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">الخصومات</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل الإجمالي الخصم"
              value={editRecord.total_deduction || ""}
              onChange={(e) =>
                setEditRecord({
                  ...editRecord,
                  total_deduction: +e.target.value,
                })
              }
            />
            {errors?.total_deduction && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.total_deduction[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">المكافآت</label>
            <Input
              type="number"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل إجمالي المكافآت"
              value={editRecord.total_bonus || ""}
              onChange={(e) =>
                setEditRecord({ ...editRecord, total_bonus: +e.target.value })
              }
            />
            {errors?.total_bonus && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.total_bonus[0]}
              </p>
            )}
          </div>

          {/* <div className="space-y-2">
            <label className="block font-medium">الدفع</label>
            <Input
              type="text"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل حالة الدفع أو التاريخ"
              value={editRecord.payed || ""}
              onChange={(e) =>
                setEditRecord({ ...editRecord, payed: e.target.value })
              }
            />
            {errors?.payed && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.payed[0]}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label className="block font-medium">دفع بواسطة</label>
            <Input
              type="text"
              className="w-full p-2 border rounded mt-1"
              placeholder="أدخل اسم الجهة الدافعة"
              value={editRecord.payed_by || ""}
              onChange={(e) =>
                setEditRecord({ ...editRecord, payed_by: e.target.value })
              }
            />
            {errors?.payed_by && (
              <p className="text-red-500 font-semibold text-sm">
                {errors.payed_by[0]}
              </p>
            )}
          </div> */}

          <div className="text-end">
            <Button onClick={handleEdit} disabled={loadingEdit}>
              {loadingEdit ? "جاري التعديل..." : "تعديل"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
